<template>
  <div>
    <v-row>
      <div class="layout-invoice">
        <v-container fluid>
          <template v-if="!loading">
            <!--Invoice body-->
            <invoice-body :loading="loading" :invoice="invoice" :contact="contact" text/>
            <!--Payments history-->
            <invoice-history v-if="payments.length" :payments="payments" text/>
          </template>
          <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
        </v-container>
      </div>
    </v-row>
  </div>
</template>

<script>
import amapi from '@/api/amapi'
import { mapActions } from 'vuex'
import InvoiceBody from '@/components/Billing/BillingInvoice/InvoiceBody'
import InvoiceHistory from '@/components/Billing/BillingInvoice/InvoiceHistory'

export default {
  name: 'PrintInvoice',
  props: {
    invoiceid: {
      type: String,
      required: true
    }
  },
  components: {
    InvoiceBody,
    InvoiceHistory,
  },
  data () {
    return {
      loading: true,
      contact: {},
      invoice: {},
      payments: [],
    }
  },
  methods: {
    ...mapActions(['reportError']),
    async getInvoice () {
      try {
        const data = {
          id: this.invoiceid
        }
        const response = await amapi.makecall('invoice', { ...data })
        if (response.result === 'success') {
          this.contact = response.contact
          this.invoice = response.invoice
          if (response.payments) {
            this.payments = response.payments
          }
        }
        this.loading = false
        this.$vuetify.theme.dark = false
        this.$nextTick(() => {
          setTimeout(() => {
            this.$vuetify.theme.dark = false
            window.print() // open browser's print dialog
          }, 200)
        })
      } catch (e) {
        this.reportError(e)
      }
    },
  },
  created () {
    this.getInvoice()
  }
}
</script>

<style>
  @media print {
    /* Fix for colour printing */
    * {
      color: inherit !important;
    }
  }
  .layout-invoice {
    background-color: white;
  }
</style>
